import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {SplitText} from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger, SplitText);
window.addEventListener('load', () => {
const isMobileFirstLoad = window.innerWidth < 768;



const callBackCardAnimation = (className) => {
    const cardsPhoto = document.querySelectorAll(className);

    cardsPhoto.forEach((card) => {
        const tlCard = gsap.timeline({
            paused: true,
            ease: 'power1.in',
            smoothChildTiming: true
        });

        tlCard.to(
            card.querySelectorAll('.block-reveal *'),
            {
                translateY: '-100%',
                duration: 0.25,
                onComplete: () => {
                    gsap.set(card.querySelectorAll('.hover-reveal'), {
                        display: 'inline-block'
                    });
                    gsap.set(card.querySelectorAll('.block-reveal *'), {
                        translateY: '100%'
                    });
                }
            },
            '<'
        );

        tlCard.to(
            card.querySelectorAll('.block-reveal *'),
            {
                translateY: '0%',
                duration: 0.25,
                onReverseComplete: () => {
                    gsap.set(card.querySelectorAll('.hover-reveal'), {
                        display: 'none'
                    });
                }
            },
            '>'
        );

        tlCard.to(
            card.querySelectorAll('.hover-reveal *'),
            {
                translateY: '0%',
                duration: 0.25
            },
            '<'
        );

        card.addEventListener('mouseenter', () => {
            tlCard.play();
        });
        card.addEventListener('mouseleave', () => {
            tlCard.reverse();
        });

        // if the cursor is currently on the card, play the animation (because the user can be on the card and the event mouse enter will not be triggered)
        if (card.matches(':hover')) {
            tlCard.play();
        }
    });
};


if (!isMobileFirstLoad) {
const tlCardsPhoto = gsap.timeline({
    scrollTrigger: {
        trigger: '.mksun-cards-photo'
    }
});

const titleCardsPhoto = new SplitText('.mksun-cards-photo .timeline-text-reveal', {
    type: 'words'
});

tlCardsPhoto.from(
    titleCardsPhoto.words,
    {
        y: '100%',
        opacity: 0,
        duration: 0.5,
        ease: 'power1.out',
        stagger: 0.1
    },
    '<'
);

tlCardsPhoto.from(
    '.mksun-cards-photo .mksun-card-photo',
    {
        stagger: {
            amount: 0.5,
            onStart: function () {
                gsap.to(this.targets()[0].querySelectorAll('.mksun-card-photo__bg'), {
                    width: '100%',
                    opacity: 1,
                    duration: 0.5,
                    ease: 'power1.out'
                });
            },
            onComplete: function () {
                gsap.to(this.targets()[0].querySelectorAll('.block-reveal *'), {
                    opacity: 1,
                    translateY: 0,
                    duration: 0.5,
                    ease: 'power1.out'
                });
            }
        },
        onComplete: () => {
            callBackCardAnimation('.mksun-card-photo:not(.mksun-card-photo--static)');
        }
    },
    '<'
);
} else {
    gsap.set('.mksun-card-photo__bg', {
        width: '100%',
        opacity: 1
    });
    gsap.set('.block-reveal *', {
        opacity: 1,
        translateY: 0
    });
    callBackCardAnimation('.mksun-card-photo:not(.mksun-card-photo--static)');
}});